function isMobile(): boolean {
  return window.innerWidth < 768 || /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export async function shareOrCopy(params: {
  url: string;
  title?: string;
  text?: string;
}): Promise<'shared' | 'copied' | 'failed'> {
  if (isMobile() && navigator.share) {
    try {
      await navigator.share({ title: params.title, text: params.text, url: params.url });
      return 'shared';
    } catch (e) {
      if ((e as DOMException).name === 'AbortError') return 'failed';
    }
  }

  try {
    await navigator.clipboard.writeText(params.url);
    return 'copied';
  } catch {
    return legacyCopy(params.url) ? 'copied' : 'failed';
  }
}

function legacyCopy(text: string): boolean {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  ta.style.pointerEvents = 'none';
  document.body.appendChild(ta);
  ta.select();
  try {
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    document.body.removeChild(ta);
  }
}
